import { PATH_ZGT } from '@components/LocalMerchant/ZhiGuangTong/constant'
import {
  ACCOUNT_MANAGE_PATH_A,
  APPRAISE_LIST_PATH,
  COUPONS_PATH_A,
  DECORATION_PATH_A,
  EDIT_CASE_PATH_A,
  EDIT_STORE_CASE_PATH_A,
  EDIT_STORE_PATH,
  EXPERIENCE_SHOP_COOP_MANAGE_A,
  LIVE_MANAGE_PATH_A,
  MATERIAL_PATH_A,
  ORDER_PATH_A,
  PROPERTY_WEDDING_PHOTO_ID,
  PUBLISH_MEAL_PATH_A,
  PUBLISH_SING_PRODUCT_PATH_A,
  SUCCESSFULLY_OPENED_PATH
} from '@constant'
import { appendUrlQuery } from '@core/utils'
import { getObjValue } from '@hlj/hlj-utils'
import { isSiDaProperty } from '@merchant-backend/util'
import { getMerchantInfo, isHotelMerchant, isStoreAccount } from '@util'
import moment from 'moment'

export const notify_type = [
  {
    id: '31',
    name: '档期提醒',
    iconId: 1,
    hidden: !isSiDaProperty(),
    isDefault: true // 是否是默认tab
  },
  {
    id: '2',
    name: '订单消息',
    iconId: 1,
    isDefault: true
  },
  {
    id: '4',
    name: '预约消息',
    iconId: 2,
    isDefault: true
  },
  {
    id: '19',
    name: '发券助手',
    iconId: 8
  },
  {
    id: '3',
    name: '活动助手',
    iconId: 3
  },
  {
    id: '17',
    name: '互动消息',
    iconId: 4
  },
  {
    id: '16',
    name: '评价助手',
    iconId: 5
  },
  {
    id: '6',
    name: '营收消息',
    iconId: 6,
    hidden: isHotelMerchant()
  },
  {
    id: '-1',
    name: '系统通知',
    iconId: 7
  }
]

// 每个消息的跳转链接
export const getLink = item => {
  const {
    notify_type,
    action,
    entity_id,
    content,
    parent_entity_id,
    web_route,
    wap_route,
    user_id,
    created_at,
    set_meal_id
  } = item
  const extra_objects = item.extra_objects || {}
  let linkUrl = '' // 特殊处理
  let commodity_type
  const merchant_id = getMerchantInfo().id

  if (web_route) {
    linkUrl =
      web_route.indexOf('http') >= 0
        ? web_route
        : `${web_route[0] == '#' ? '' : '#'}${web_route}`
  } else if (wap_route) {
    linkUrl =
      wap_route.indexOf('http') >= 0
        ? wap_route
        : `${wap_route[0] == '#' ? '' : '#'}${wap_route}`
  }
  if (action == 'audit_success' || action == 'audit_fail') {
    commodity_type = extra_objects.set_meal.commodity_type
  }
  if (action == 'audit_success') {
    if (commodity_type == '0') {
      // 套餐
      // eslint-disable-next-line
      linkUrl = `${__HUNLIJI_DOMAIN__}/package/detail_${entity_id}?admin=true`
    } else if (commodity_type == '1') {
      // 案例
      // eslint-disable-next-line
      linkUrl = `${__HUNLIJI_DOMAIN__}/example/detail_${entity_id}?admin=true`
    }
  }
  if (action == 'audit_fail') {
    const property_id = getObjValue(item, 'extra_objects.set_meal.property_id')
    const second_category_id = getObjValue(
      item,
      'extra_objects.set_meal.second_category_id'
    )
    // single_product 0是套餐  1是男士  2是女士
    const { single_product } = item
    linkUrl = `${PUBLISH_MEAL_PATH_A}/${entity_id}`
    if (commodity_type == '0') {
      if (single_product == 0) {
        if (property_id == PROPERTY_WEDDING_PHOTO_ID) {
          linkUrl = `${linkUrl}?weddingPhotoType=${second_category_id}`
        } else if (isStoreAccount()) {
          linkUrl = `${linkUrl}&propertyId=${property_id}`
        }
      } else {
        linkUrl = `${PUBLISH_SING_PRODUCT_PATH_A}/${entity_id}?isSingle=1&gender=${
          single_product == 2 ? 0 : 1
        }`
      }
    } else if (commodity_type == '1') {
      linkUrl = `${EDIT_CASE_PATH_A}/${entity_id}?propertyId=${property_id}`
      if (isStoreAccount()) {
        linkUrl = `${EDIT_STORE_CASE_PATH_A}/${entity_id}?propertyId=${property_id}`
      }
    }
  }
  if (notify_type == 9 && action != 'merchant_notify_text') {
    let _json = JSON.parse(content || null)
    if (action == 'merchant_notify_feature') {
      if (_json.target_type == '100') {
        linkUrl =
          '/p/wedding/Public/admin/local_merchant_react/dist/index.html#/localMerchant/myShop'
      } else if (_json.target_type == '101') {
        linkUrl =
          '/p/wedding/Public/admin/local_merchant_react/dist/index.html#/localMerchant/marketingTools'
      } else if (_json.target_type == '102') {
        linkUrl = `/p/wedding/Public/admin/local_merchant_react/dist/index.html#${EDIT_STORE_PATH}`
      }
    } else if (action == 'merchant_notify_html') {
      linkUrl = _json.target_url
    }
  }
  if (notify_type == 10 || notify_type == 17) {
    if (
      action == 'post_qa_answer_hot' &&
      moment('2019-12-05 12:00:00').isBefore(created_at)
    ) {
      // 服务端没办法处理老数据，就只能判断时间了，太南了。。。
      linkUrl = `#/localMerchant/communityDetail/${parent_entity_id}`
    } else if (
      [
        'video_praise',
        'video_comment',
        'video_comment_reply',
        'video_comment_praise',
        'mix_comment_video'
      ].includes(action) &&
      extra_objects['note_id']
    ) {
      linkUrl = `#/localMerchant/dynamicDetail/${extra_objects.note_id}`
    }
  }
  if (notify_type == 7) {
    if (
      [
        'short_video_list_recommend_to_merchant',
        'short_video_review_pass_to_merchant',
        'short_video_review_fail_to_merchant'
      ].includes(action) &&
      extra_objects['note_id']
    ) {
      linkUrl = `#/localMerchant/dynamicDetail/${extra_objects.note_id}`
    }
  }
  if (notify_type == 2) {
    if (
      ![
        'brokerage_deduct',
        'brokerage_refund',
        'apply_refund',
        'hotel_send_order',
        'test_store_send_order'
      ].includes(action)
    ) {
      linkUrl = `${ORDER_PATH_A}/detail/${entity_id}`
    }
  }
  if (notify_type == 24) {
    if (action === 'online_merchant_expire_notify') {
      const param = window.btoa(
        JSON.stringify({
          proDate:
            extra_objects.expired_at && extra_objects.expired_at.substr(0, 10),
          type: 'other'
        })
      )
      linkUrl = appendUrlQuery(linkUrl, {
        payParams: '{"is_online_shop":1}',
        return_url: SUCCESSFULLY_OPENED_PATH + `?param=${param}`
      })
    }
  }

  if (linkUrl) {
    return linkUrl
  }
  const { title, id } = extra_objects.expand || {}

  const actionMap = {
    update_marketing_meal_status: `#/localMerchant/activityRegister/activityDetail/${parent_entity_id}`,
    marketing_activity_meal_examine: `#/localMerchant/activityRegister/activityDetail/${
      item.participant_id
    }`,
    marketing_activity_examine: `#/localMerchant/activityRegister/activityDetail/${
      item.participant_id
    }?positionId=${entity_id}`,
    live_channel_report_examine: `${LIVE_MANAGE_PATH_A}/reportForm/${entity_id}`,
    live_channel_examine_success: `${LIVE_MANAGE_PATH_A}/controlBoard/${entity_id}`,
    live_channel_examine_fail: `${LIVE_MANAGE_PATH_A}/reportForm/${entity_id}`,
    live_start: `${LIVE_MANAGE_PATH_A}/controlBoard/${entity_id}`,
    live_self_end: `${LIVE_MANAGE_PATH_A}/controlBoard/${entity_id}`,
    live_flow_limit: `${LIVE_MANAGE_PATH_A}/controlBoard/${entity_id}`,
    merchant_material_notify: MATERIAL_PATH_A,
    cpt_set_meal_schedule_add: `#/localMerchant/marketingCenter/paymentDetail?id=${
      extra_objects.merchant_order_id
    }`,
    merchant_no_area_id: '#/localMerchant/editStore',
    proof_from_user: `#/localMerchant/appraise/appeal/${entity_id}`,
    appeal_success_to_merchant: `#/localMerchant/appraise/appeal/${entity_id}`,
    appeal_fail_to_merchant: `#/localMerchant/appraise/appeal/${entity_id}`,
    order_comment_review_pass: `#/localMerchant/appraise`,
    high_quality_note: `#/localMerchant/creation`,
    weapp_share_expire: `#/localMerchant/liteApp/manage`,
    weapp_exclusive_expire: `#/localMerchant/liteApp/manage`,
    receive: `${COUPONS_PATH_A}/receive/${id}?title=${title}`,
    // eslint-disable-next-line
    collect_case: `${__HUNLIJI_DOMAIN__}/example/detail_${entity_id}?admin=true`,
    // eslint-disable-next-line
    forwarding_case: `${__HUNLIJI_DOMAIN__}/example/detail_${entity_id}?admin=true`,
    appeal_success: `/p/wedding/Public/admin/local_merchant_react/dist/index.html#/localMerchant/AppealResult/${entity_id}`,
    appeal_failed: `/p/wedding/Public/admin/local_merchant_react/dist/index.html#/localMerchant/AppealResult/${entity_id}`,
    merchant_audit_success: `/p/wedding/Public/admin/local_merchant_react/dist/index.html#${EDIT_STORE_PATH}`,
    merchant_audit_fail: `/p/wedding/Public/admin/local_merchant_react/dist/index.html#${EDIT_STORE_PATH}`,
    merchant_and_setmeal: `/p/wedding/Public/admin/local_merchant_react/dist/index.html#${EDIT_STORE_PATH}`,
    order_comment_merchant: `/p/wedding/Public/admin/local_merchant_react/dist/index.html#${APPRAISE_LIST_PATH}`,
    order_comment_review_reply_merchant: `/p/wedding/Public/admin/local_merchant_react/dist/index.html#${APPRAISE_LIST_PATH}`,
    qa_question_appeal_success: `/p/wedding/Public/admin/local_merchant_react/dist/index.html#/localMerchant/appealResult/${entity_id}?kind=question`,
    qa_question_appeal_failed: `/p/wedding/Public/admin/local_merchant_react/dist/index.html#/localMerchant/appealResult/${entity_id}?kind=question`,
    qa_question_merchant: `/p/wedding/Public/admin/local_merchant_react/dist/index.html#${APPRAISE_LIST_PATH}/qa/${entity_id}?merchant_id=${merchant_id}&user_id=${user_id}`,
    qa_answer_merchant: `/p/wedding/Public/admin/local_merchant_react/dist/index.html#${APPRAISE_LIST_PATH}/qa/${parent_entity_id}?merchant_id=${merchant_id}&user_id=${user_id}`,
    merchant_certify_identity_fail:
      '/p/wedding/Public/admin/local_merchant_react/dist/index.html#/modifyPhone/verify',
    merchant_certify_identity_pass:
      '/p/wedding/Public/admin/local_merchant_react/dist/index.html#/modifyPhone/verify',
    ad_stop_plan:
      '/p/wedding/Public/admin/local_merchant_react/dist/index.html#/localMerchant/promotion_management',
    ad_stop_daily_plan:
      '/p/wedding/Public/admin/local_merchant_react/dist/index.html#/localMerchant/promotion_management'
  }

  if (actionMap[action]) {
    return actionMap[action]
  }
  const typeActionMap = {
    10: {
      note_join_repository: `#/localMerchant/dynamicDetail/${entity_id}`,
      merchant_feed_praise: `#/localMerchant/dynamicDetail/${parent_entity_id}`,
      note_comment: `#/localMerchant/dynamicDetail/${parent_entity_id}`,
      question_user_callback: `#/localMerchant/communityDetail/${entity_id}`,
      note_user_callback: '#/localMerchant/creation',
      note_comment_reply: `#/localMerchant/dynamicDetail/${parent_entity_id}`
    },
    17: {
      note_join_repository: `#/localMerchant/dynamicDetail/${entity_id}`,
      merchant_feed_praise: `#/localMerchant/dynamicDetail/${parent_entity_id}`,
      note_comment: `#/localMerchant/dynamicDetail/${parent_entity_id}`,
      question_user_callback: `#/localMerchant/communityDetail/${entity_id}`,
      note_user_callback: '#/localMerchant/creation',
      note_comment_reply: `#/localMerchant/dynamicDetail/${parent_entity_id}`,
      // eslint-disable-next-line
      collect_style: `${__HUNLIJI_DOMAIN__}/p/wedding/Public/wap/m/wedding-dress-details/#/index?id=${set_meal_id}`
    },
    7: {
      MerchantBank: `/p/wedding/Public/admin/local_merchant_react/dist/index.html${ACCOUNT_MANAGE_PATH_A}/account`,
      audit_style_fail: '#/localMerchant/addressStyle/auditList?status=3',
      audit_style_success: '#/localMerchant/addressStyle',
      merchant_notice_fail: '#/localMerchant/notice',
      merchant_notice_pass: '#/localMerchant/notice',
      merchant_video_pass: DECORATION_PATH_A,
      merchant_video_fail: DECORATION_PATH_A,
      merchant_materials_fail: MATERIAL_PATH_A,
      merchant_materials_pass: MATERIAL_PATH_A
    },
    2: {
      brokerage_deduct: `${EXPERIENCE_SHOP_COOP_MANAGE_A}/detail/${entity_id}`,
      brokerage_refund: `${EXPERIENCE_SHOP_COOP_MANAGE_A}/detail/${entity_id}`,
      apply_refund: `${ORDER_PATH_A}/detail/${parent_entity_id}`,
      hotel_send_order: `#/localMerchant/experienceShop/detail/${entity_id}`,
      test_store_send_order: `#/localMerchant/experienceShop/detail/${entity_id}`
    },
    13: {
      ad_poor_merchant: `#${PATH_ZGT}`,
      ad_stop_plan: `#/localMerchant/promotion_management`
    },
    24: {
      merchant_server_fee: EXPERIENCE_SHOP_COOP_MANAGE_A
    },
    31: {
      emcee_schedule_week_notify: '#/localMerchant/scheduleTool',
      emcee_schedule_day_notify: '#/localMerchant/scheduleTool'
    },
    32: {
      invite: '#/localMerchant/groupInvite'
    },
    34: {
      cpm_ad_exception: `#/localMerchant/zhiGuangTong/edit/${extra_objects.id}`
    }
  }
  return getObjValue(typeActionMap, `${notify_type}.${action}`)
}

// 每个消息的跳转链接（团队账号）
export const getLinkTeam = item => {
  const {
    notify_type,
    action,
    entity_id,
    content,
    parent_entity_id,
    web_route,
    wap_route,
    user_id,
    entity
  } = item
  const extra_objects = item.extra_objects || {}
  let linkUrl = '' // 特殊处理
  const merchant_id = getMerchantInfo().id

  if (web_route) {
    linkUrl =
      web_route.indexOf('http') >= 0
        ? web_route
        : `${web_route[0] == '#' ? '' : '#'}${web_route}`
  } else if (wap_route) {
    linkUrl =
      wap_route.indexOf('http') >= 0
        ? wap_route
        : `${wap_route[0] == '#' ? '' : '#'}${wap_route}`
  }
  if (notify_type == 9 && action != 'merchant_notify_text') {
    let _json = JSON.parse(content || null)
    if (action == 'merchant_notify_feature') {
      if (_json.target_type == '100') {
        linkUrl = '/p/wedding/Public/admin/order/merchant_grade.html#grade_info'
      } else if (_json.target_type == '101') {
        linkUrl = '/p/wedding/Public/admin/order/marking_set.html#discount'
      } else if (_json.target_type == '102') {
        linkUrl = `/p/wedding/Public/admin/order/account_settings.html#data_settings`
      }
    } else if (action == 'merchant_notify_html') {
      linkUrl = _json.target_url
    }
  }
  if (notify_type == 7) {
    if (entity == 'MerchantBank') {
      linkUrl = `/p/wedding/Public/admin/local_merchant_react/dist/index.html#/store/accountManage/account`
    }
  }
  if (notify_type == 2) {
    if (action != 'apply_refund') {
      linkUrl = `#/localMerchant/orderManage_new/detail/${entity_id}`
    }
  }
  if (notify_type == 24) {
    if (action === 'online_merchant_expire_notify') {
      const param = window.btoa(
        JSON.stringify({
          proDate:
            extra_objects.expired_at && extra_objects.expired_at.substr(0, 10),
          type: 'other'
        })
      )
      linkUrl = appendUrlQuery(linkUrl, {
        payParams: '{"is_online_shop":1}',
        return_url: SUCCESSFULLY_OPENED_PATH + `?param=${param}`
      })
    }
  }

  if (linkUrl) {
    return linkUrl
  }
  const actionMap = {
    proof_from_user: `#/localMerchant/appraise/appeal/${entity_id}`,
    appeal_success_to_merchant: `#/localMerchant/appraise/appeal/${entity_id}`,
    appeal_fail_to_merchant: `#/localMerchant/appraise/appeal/${entity_id}`,
    order_comment_review_pass: `#/localMerchant/appraise`,
    high_quality_note: `#/localMerchant/dynamic`,
    order_comment_merchant: `/p/wedding/Public/admin/local_merchant_react/dist/index.html#${APPRAISE_LIST_PATH}`,
    qa_question_merchant: `/p/wedding/Public/admin/local_merchant_react/dist/index.html#${APPRAISE_LIST_PATH}/qa/${entity_id}?merchant_id=${merchant_id}&user_id=${user_id}`,
    qa_answer_merchant: `/p/wedding/Public/admin/local_merchant_react/dist/index.html#${APPRAISE_LIST_PATH}/qa/${parent_entity_id}?merchant_id=${merchant_id}&user_id=${user_id}`
  }

  if (actionMap[action]) {
    return actionMap[action]
  }
  const typeActionMap = {
    7: {
      merchant_video_pass: DECORATION_PATH_A,
      merchant_video_fail: DECORATION_PATH_A,
      merchant_materials_fail: MATERIAL_PATH_A,
      merchant_materials_pass: MATERIAL_PATH_A,
      real_photo_success: DECORATION_PATH_A,
      real_photo_fail: DECORATION_PATH_A
    },
    2: {
      apply_refund: `#/localMerchant/orderManage_new/detail/${parent_entity_id}`
    },
    13: {
      ad_poor_merchant: `#/localMerchant/money-transfers`,
      ad_stop_plan: `#/localMerchant/promotion_management`
    },
    31: {
      emcee_group_schedule_week_notify: '#/localMerchant/scheduleTool',
      emcee_group_schedule_day_notify: '#/localMerchant/scheduleTool'
    },
    32: {
      apply: '#/localMerchant/groupApply'
    }
  }
  return getObjValue(typeActionMap, `${notify_type}.${action}`)
}

// 每个消息的内容
export const getContent = item => {
  const { notify_type, content, action, body } = item
  const title = getObjValue(item, 'extra_objects.expand.title')
  const contentMap = {
    16: {
      qa_answer_merchant: `${item.participant_name || ''}于 ${
        item.created_at
      } 回答了问题`,
      qa_question_merchant: `${item.participant_name || ''}于 ${
        item.created_at
      } 发起了问题`,
      order_comment_merchant: content
    },
    10: {
      qa_answer_praise:
        `${item.participant_name} ${item.body} ` +
        (title ? '"' + title + '"' : ''),
      qa_answer_comment:
        `${item.participant_name} ${item.body} ` +
        (title ? '"' + title + '"' : ''),
      post_qa_answer_hot:
        `${item.participant_name} ${item.body} ` +
        (title ? '"' + title + '"' : ''),
      qa_praise:
        `${item.participant_name} ${item.body} ` +
        (title ? '"' + title + '"' : '')
    },
    7: `${item.body} ${content || ''}`,
    9: {
      merchant_notify_text: `${item.body} ${content}`
    },
    3: content,
    17: content,
    23: body
  }
  if (typeof contentMap[notify_type] == 'string') {
    return contentMap[notify_type]
  }
  return getObjValue(contentMap, `${notify_type}.${action}`) || body || content
}

// 每个消息的内容（团队账号）
export const getContentTeam = item => {
  const { notify_type, content, action, body } = item
  const contentMap = {
    16: {
      qa_answer_merchant: `${item.participant_name || ''}于 ${
        item.created_at
      } 回答了问题`,
      qa_question_merchant: `${item.participant_name || ''}于 ${
        item.created_at
      } 发起了问题`,
      order_comment_merchant: content
    },
    10: {
      qa_answer_praise: `${item.participant_name} ${body}`
    },
    7: `${body} ${content || ''}`,
    9: {
      merchant_notify_text: `${body} ${content || ''}`
    },
    3: content,
    17: content
  }
  if (typeof contentMap[notify_type] == 'string') {
    return contentMap[notify_type]
  }
  return getObjValue(contentMap, `${notify_type}.${action}`) || body || content
}
